import React, { useContext, useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { CartContext } from "../context/CartContext";
import FormatPrice from "../helper/FormatPrice";
import "./OrderItems.css";

const OrderItems = (curElem) => {
  const {
    sku,
    product_sku,
    product_id,
    qty,
    name,
    price,
    image,
    cut,
    color,
    product_name,
    product_image,
    metal,
    shape,
    style,
    clarity,
    carat,
  } = curElem;

  const loggedInUser = localStorage.getItem("token");

  return (
    <>
      {loggedInUser && (
        <div className="row">
          <div className="col-3">
            <NavLink
              to={`/singleproduct/${product_sku}`}
              className="fw-bold orderHeading my-0 link-dark d-block"
            >
              <img
                src={product_image.toString().split(",")[0]}
                width={100}
                height={100}
              />
            </NavLink>
          </div>

          <div className="col-9">
            <NavLink
              to={`/singleproduct/${product_sku}`}
              className="fw-bold orderHeading my-0 link-dark d-block"
            >
              {product_name} {product_id}
            </NavLink>
            <span className="fw-bold orderHeading">
              <FormatPrice price={price} /> x {qty}
            </span>
            <br />
            <span className="fw-bold orderSpan">Made-to-Order.</span>{" "}
            <span className="orderSpan">
              Estimated Ship Date: Thursday, August 10th
            </span>
          </div>
          <hr className="my-2" />
        </div>
      )}

      {!loggedInUser && (
        <div className="row">
          <div className="col-3">
            <NavLink
              to={`/singleproduct/${sku}`}
              className="fw-bold orderHeading my-0 link-dark d-block"
            >
              <img
                src={image.toString().split(",")[0]}
                width={100}
                height={100}
              />
            </NavLink>
          </div>

          <div className="col-9">
            <NavLink
              to={`/singleproduct/${sku}`}
              className="fw-bold orderHeading my-0 link-dark d-block"
            >
              {name} {product_id}
            </NavLink>
            <span className="fw-bold orderHeading">
              <FormatPrice price={price} /> x {qty}
            </span>
            <br />
            <span className="fw-bold orderSpan">Made-to-Order.</span>{" "}
            <span className="orderSpan">
              Estimated Ship Date: Thursday, August 10th
            </span>
          </div>
          <hr className="my-2" />
        </div>
      )}
    </>
  );
};

export default OrderItems;
